export default __webpack_public_path__ + "static/media/mus3.2dfbbe16.jpeg";